import React from 'react';
import BottomDrawer from './BottomDrawer';
import useBottomDrawer from './useBottomDrawer';
const BottomDrawerHelperView = ({}) => {
    const [bottomDrawerState, bottomDrawerActions] = useBottomDrawer();
    return (React.createElement(BottomDrawer, { ...bottomDrawerState, onClose: bottomDrawerActions.hide }));
};
export default BottomDrawerHelperView;
